/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PipelineCandidateResponseCertificationsItem } from './pipelineCandidateResponseCertificationsItem';
import type { PipelineCandidateResponseContactsItem } from './pipelineCandidateResponseContactsItem';
import type { PipelineCandidateResponseEducationItem } from './pipelineCandidateResponseEducationItem';
import type { PipelineCandidateResponseExperiencesItem } from './pipelineCandidateResponseExperiencesItem';
import type { PipelineCandidateResponseLanguagesItem } from './pipelineCandidateResponseLanguagesItem';
import type { PipelineCandidateResponseSocialProfilesItem } from './pipelineCandidateResponseSocialProfilesItem';
import type { PipelineCandidateSequenceInfo } from './pipelineCandidateSequenceInfo';
import type { StageResponse } from './stageResponse';

export interface PipelineCandidateResponse {
  job_candidate_id: string;
  profile_id: string;
  full_name?: string | null;
  avatar_url?: string | null;
  job_title?: string | null;
  company?: string | null;
  company_domain?: string | null;
  location?: string | null;
  stage_id?: string | null;
  stage_name?: string | null;
  origin: string;
  ats_connector_id?: string | null;
  ats_connector_name?: string | null;
  ats_application_linked?: boolean;
  ats_remote_url?: string | null;
  ats_sync_state?: string;
  ats_sync_error?: string | null;
  ats_sync_pending_action?: string | null;
  held_state?: string | null;
  parse_status?: string | null;
  skills?: string[];
  linkedin_url?: string | null;
  github_url?: string | null;
  twitter_url?: string | null;
  social_profiles?: PipelineCandidateResponseSocialProfilesItem[];
  email?: string | null;
  phone?: string | null;
  headline?: string | null;
  summary?: string | null;
  experiences?: PipelineCandidateResponseExperiencesItem[];
  education?: PipelineCandidateResponseEducationItem[];
  languages?: PipelineCandidateResponseLanguagesItem[];
  certifications?: PipelineCandidateResponseCertificationsItem[];
  total_experience_months?: number | null;
  total_experience_years?: number | null;
  current_role_months?: number | null;
  avg_tenure_months?: number | null;
  resume_url?: string | null;
  stage?: StageResponse | null;
  added_at: string;
  stage_entered_at: string;
  contacts?: PipelineCandidateResponseContactsItem[];
  already_revealed?: boolean;
  sequences?: PipelineCandidateSequenceInfo[];
}
